module.exports = __webpack_public_path__ + "static/img/wealth_level_79.eafd253.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/level/wealth_level_79.png
// module id = 24gW
// module chunks = 0